import { useRef } from 'react'
import { useDispatch } from 'react-redux'

import { historyPush } from 'actions/core/navigation'
import { useGetUserQuery } from 'common'
import { getSidebarOptions, useEventTypeEditorSidebar } from 'features/event_type_editor'
import { useToggleState } from 'hooks/useToggleState'

import { UserGroupPopup } from './user_group_popup'

export const useCreateBaseEventType = () => {
  const dispatch = useDispatch()
  const selectedKindRef = useRef()
  const [isPopupOpen, togglePopup] = useToggleState(false)
  const { openSidebar: openEventTypeSidebar } = useEventTypeEditorSidebar()

  const { data: currentUser } = useGetUserQuery()

  const isUserGroupAdmin = !currentUser.organization_membership.is_admin_or_owner && currentUser.is_user_group_admin
  const userAdminGroups = Object.values(currentUser.user_group_relationships || {})
    .filter((group) => group.admin)
    .map((group) => ({
      groupId: group.admin.group_id,
      groupName: group.admin.group_name,
      groupUuid: group.admin.group_uuid
    }))

  const isRestricted = isUserGroupAdmin && userAdminGroups.length === 0
  const isUserSingleGroupAdmin = isUserGroupAdmin && userAdminGroups.length === 1
  const isUserMultipleGroupAdmin = isUserGroupAdmin && userAdminGroups.length > 1

  const handleCreateBaseEventType = (kind, ownerType = 'Organization', groupUuid = undefined) => {
    const metPagePath = '/app/admin/managed_event_types'

    if (window.location.pathname !== metPagePath) { dispatch(historyPush(metPagePath)) }

    openEventTypeSidebar(getSidebarOptions({
      type: 'ManagedEventType',
      kind,
      groupUuid
    }))
  }

  const handleUserGroupPopupApply = ({ selectedUserGroup }) => {
    const { group_uuid: groupUuid } = selectedUserGroup

    togglePopup()
    handleCreateBaseEventType(selectedKindRef.current, 'Group', groupUuid)
  }

  const handleDifferentUserTypeFlows = (kind) => {
    if (isUserSingleGroupAdmin) {
      handleCreateBaseEventType(kind, 'Group', userAdminGroups[0].groupUuid)
    } else if (isUserMultipleGroupAdmin) {
      selectedKindRef.current = kind
      togglePopup()
    } else {
      handleCreateBaseEventType(kind)
    }
  }
  return {
    isRestricted,
    isUserSingleGroupAdmin,
    isUserMultipleGroupAdmin,
    userAdminGroups,
    handleCreateBaseEventType,
    handleUserGroupPopupApply,
    handleDifferentUserTypeFlows,
    UserGroupPopup: <UserGroupPopup
      isOpen={isPopupOpen}
      onClose={togglePopup}
      handleApply={handleUserGroupPopupApply}
      showCancelButton
    />
  }
}
